/* eschannelOptionslint eqeqeq: "off", curly: "error", @typescript-eslint/no-unused-vars: "off", react-hooks/exhaustive-deps: "off", array-callback-return: "off", no-eval: "off", jsx-a11y/alt-text: "off", jsx-a11y/anchor-is-valid: "off" */
import React, { useState, useEffect } from 'react';
import { closelightbox } from '../../util/Functions';
import { format, formatNumericDate } from "../../util/DateUtil";
import * as API from '../../http/api';
import { Grid, TextField, Button, DialogActions, DialogContent, Dialog, DialogTitle, IconButton, MenuItem, Tooltip } from "@mui/material";
import { ModalStyle } from "../../util/Styles";
import { Close, Search } from "@mui/icons-material";
import moment from 'moment';
import 'moment/locale/es';
import { importOptions, statusOptions, channelOptions, claimsOptions, eventOptions, operationOptions, accountType } from '../../util/DataObject';
import { parseDate, DateRangePicker, transformTzDate } from '../elements/DateRangePicker';
import CustomPagination from '../elements/CustomPagination';

const R27 = (props) => {
    const [step, setStep] = useState(1);
    const [hasUpdate, setHasUpdate] = useState(false);
    const [disabled, setDisabled] = useState(false);
    const [showImporteRecuperado, setImporteRecuperado] = useState(false);
    const [quebranto, setQuebranto] = useState('0');
    const [listTx, setListTx] = useState([]);
    const [newListTx, setNewListTx] = useState([]);
    const [account, setAccount] = useState('cuenta');
    const [resolveOptions, setResolveOptions] = useState([]);
    const [reasonOptions, setReasonOptions] = useState([]);

    const [recuperado, setRecuperado] = useState('0');
    const [showPdate, setShowPdate] = useState(true);
    const [isValid, setIsValid] = useState(false);
	const [rowsPerPage, setRowsPerPage] = useState(20);
	const [totalRows, setTotalRows] = useState(0);
	const [page, setPage] = useState(1);
	const [newDates, setNewDates] = useState({});

    const REGEX_FOLIO = /^[0-9A-ZÑ]{8,22}$/;
    const REGEX_REMOTE_FIDEICOMISO = /^[A-Z0-9]{8,50}$/;
    const REGEX_REMOTE_ACCOUNT = /^[A-Z0-9]{8,11}$/;
    const REGEX_AMOUNT = /^-?(?:0|[1-9]\d{0,2}(?:,?\d{3})*)(?:\.\d{0,4})?$/;

    const [oldStatusRec, setOldStatusRec] = useState("");
    const [msnErrorQuebrantado, setMsnErrorQuebrantado] = useState("");
    const [zPos, setZPos] = useState(45)

    const text = ['Campo obligatorio', 'Dato obligatorio', 'Dato inválido, mínimo 8 caracteres']

    const [data, setData] = useState({
        uuid: props.data.uuid,
        id_complaint: "",
        status_complaint: "101",
        udate_status: new Date().toISOString(),
        customer_uuid: props.customer.uuid,
        id_account: props.data.panMasked,
        movement_id: props.data.tracking_key,
        status: "in_progress",
        complaint: {
            cdate: new Date().toISOString(),
            channel: "205",
            type: "301",
            reason: "0",
            description: ""
        },
        event: {
            cdate: props.data.cdate,
            object: "0",
            channel: "0",
            amount: props.data.amount
        },
        resolve: {
            cdate: "",
            sentido: "0",
            amount: props.data.amount,
            pdate: "",
            key_institution: "646180204200002645",
            ramount: 0,
            rdate: "",
            remote_account: "",
            quebranto: 0
        }
    })

    const [errorForm, setErrorForm] = useState({ 
        id_complaint: false,
        status_complaint: false,
        udate_status: false,
        customer_uuid: false,
        id_account: false,
        movement_id: false,
        complaint: {
            cdate: false,
            channel: false,
            type: false,
            reason: false,
            description: false
        },
        event: {
            cdate: false,
            object: false,
            channel: false,
            amount: false
        },
        resolve: {
            cdate: false,
            sentido: false,
            amount: false,
            pdate: false,
            key_institution: false,
            ramount: false,
            rdate: false,
            remote_account: false,
            quebranto: false
        }
    });


    useEffect(() => {
        setResolveOptions(props.catalogs[0]);
        setReasonOptions(props.catalogs[1]);
        setHasUpdate(props.data.hasUpdate)
        if(props.spacesList?.length > 0 && props.spaceUuid){
            let d = data
            var test =  props.spacesList.reduce((acc, current) => {
                if(current.uuid === props.spaceUuid){
                    acc = current.accountNumber
                }
                return acc
            }, "")

            d['id_account'] = test
            setData(JSON.parse(JSON.stringify(d)))
        }
        if(props.data.hasUpdate){
            setStep(1)
            setOldStatusRec(props.data.status_complaint);
            setData(JSON.parse(JSON.stringify(props.data)))
            if(props.data.status_complaint === "102"){
                validateUpdate(props.data)
            }
        }
        if(props.listTx){
            let allowStatus = props.listTx.filter((item) => ["approved", "on_transit", "confirmed", "settled", "accepted", "reversed" ].indexOf(item.status) > -1 && !item.chargeback)
            setListTx(allowStatus)
        }
        if(props.dates){
            setNewDates(props.dates)
        }
        if(props.pagination){
            setPage(props.pagination.page)
            setTotalRows(props.pagination.totalRows)
            setRowsPerPage(props.pagination.rowsPerPage)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const hasAction = (action) => {
        return props.config?.actions?.indexOf(action) > -1;
    };

    const validateUpdate = (data) => {
        if((data['resolve']['quebranto'] === data['resolve']['ramount'] && data['resolve']['ramount'] === data['resolve']['amount']) || (data['resolve']['quebranto'] === data['resolve']['amount'] && data['resolve']['ramount'] === 0)){
            setImporteRecuperado(false)
            setQuebranto("1")
            setRecuperado("1")
            if(validateSentido(data.resolve.sentido)){
                setShowPdate(false)
            }
        } else if((data['resolve']['quebranto'] === 0 && data['resolve']['ramount'] === data['resolve']['amount']) || (data['resolve']['quebranto'] === 0 && data['resolve']['ramount'] === 0)){
            setImporteRecuperado(false)
            setQuebranto("0")
            setRecuperado("0")
            if(validateSentido(data.resolve.sentido)){
                setShowPdate(true)
            }
        }  else {
            setImporteRecuperado(true)
            setQuebranto("2")
            setRecuperado("2")
            if(validateSentido(data.resolve.sentido)){
                setShowPdate(true)
            }
        }
    } 
    // REFACTOR ---------------------------------------------

    const handleChange = (nodo, key, e) => {
        let d = data;
        let eF = errorForm;
        let today = new Date().toISOString();
        var value = e.target.value;

        let importeR = () => {
            setShowPdate(true)
            setRecuperado(value)
            d['resolve']['pdate'] = today;

            switch (value) {
                case '2':
                    setImporteRecuperado(true)
                    setQuebranto(value)
                    d['resolve']['quebranto'] = 0
                    break;
                case '1':
                    setImporteRecuperado(false)
                    setQuebranto(value)
                    d['resolve']['quebranto'] = d['resolve']['amount']
                    if(validateSentido(data.resolve.sentido)){
                        d['resolve']['pdate'] = '';
                        setShowPdate(false)
                    }
                    break;
                default:
                    setImporteRecuperado(false)
                    setQuebranto(value)
                    d['resolve']['quebranto'] = 0
                    break;
            }
        }
        if(nodo){
            if(nodo === 'subsequent_events'){
                let keys = key.split('-')
                d[nodo][Number(keys[1])][keys[0]] = value;
            } else if(nodo === "resolve" && key === "cdate") {
                d['resolve']['cdate'] = d['resolve']['rdate'] = new Date(value).toISOString();
                d['udate_status'] = transformTzDate(value);
            } else if(nodo === "resolve" && key === "rdate" && !validateSentido(data.resolve.sentido)) {
                d['resolve']['rdate'] = new Date(value).toISOString();
                d['udate_status'] = transformTzDate(value);
            } else if(nodo === "resolve" && key === "pdate" ) {
                d['resolve']['pdate'] = new Date(value).toISOString();
            } else if(nodo === "complaint" && key === "cdate") {
                d['complaint']['cdate'] = new Date(value).toISOString();
            }  else {
                switch(key){
                    case 'ramount':
                        if( !(Number(value) <= Math.abs(d['event']['amount'])) ){
                            setMsnErrorQuebrantado("La suma del Importe recuperado y el Quebranto para albo: no debe ser mayor que el Importe abonado al cliente $" + Math.abs(d['event']['amount']))
                        }
                        var quebrantado = (d['event']['amount']) - Number(value);
                        if(isNaN(quebrantado)){
                            d['resolve']['quebranto'] = 0
                            d[nodo][key] = 0;
                        }else{
                            d['resolve']['quebranto'] = Number(quebrantado.toFixed(2))
                            d[nodo][key] = Number(value)
                        }
                        break
                    case 'remote_account':
                        d[nodo][key] = value.toUpperCase();
                        break
                    case 'sentido':
                        if(!validateSentido(value)){
                            d['resolve']['remote_account'] = '';
                            d['resolve']['ramount'] = 0
                            d['resolve']['cdate'] = d['resolve']['pdate']  = '';
                        } else {
                            showPdate ? d['resolve']['pdate'] = today :  d['resolve']['pdate'] = ''
                            d['resolve']['remote_account'] = account === 'cuenta' ? d['id_account'].slice(-10) : '';
                            d['resolve']['ramount'] = d['resolve']['amount']
                            d['resolve']['cdate'] = d['resolve']['rdate'] = today;
                            d['udate_status'] = new Date().toISOString();
                        }
                        d[nodo][key] = value;
                        break
                    default:
                        d[nodo][key] = value;
                        break
                }
            }
        } else {
            switch(key){
                case 'status_complaint':
                    if(value === '102' || value === '104'){
                        d['resolve']['remote_account'] = account === 'cuenta' ? d['id_account'].slice(-10) : '';
                        d['resolve']['ramount'] = d['resolve']['amount']
                        d['resolve']['cdate'] = d['resolve']['pdate'] = d['resolve']['rdate'] = today
                    }
                    if(oldStatusRec && oldStatusRec !== value){
                        d['udate_status'] = new Date().toISOString();
                    } else {
                        d['udate_status'] = props.data.udate_status;
                    }
                    d[key] = value;
                    setStep(1);                    
                    break
                case 'importe_recuperado':
                    importeR()
                    break
                case 'subsequent_events':
                    let txs = listTx.filter((tx) => tx.uuid !== value.uuid );
                    setNewListTx([...newListTx, value]);
                    setListTx(txs);

                    var newNodo = {
                        cdate: value.cdate,
                        object: '',
                        channel: '',
                        amount: value.amount,
                        description: value.description,
                        movement_id: value.tracking_key,
                        tipoTx: value.subtype,
                        concept: value.concept,
                        tx_uuid: value.uuid
                    }
                    if(d['subsequent_events']){
                        d['subsequent_events'] = d['subsequent_events'].concat(newNodo)
                    } else {
                        eF['subsequent_events'] = []
                        setErrorForm(JSON.parse(JSON.stringify(eF)));
                        d['subsequent_events'] = [newNodo]
                    }
                    break
                case 'id_complaint':
                    d[key] = value.toUpperCase();
                    break
                default:
                    d[key] = value;
                    break
            }
        }
        setData(JSON.parse(JSON.stringify(d)));
        setDisabled(false)
    }
    const deleteEvent = (value) => {
        let d = data;
        d['subsequent_events'].splice(value, 1);
        setData(JSON.parse(JSON.stringify(d)));
        let n =  newListTx[value];
        setListTx([...listTx, n]);
        let r = newListTx
        r.splice(value, 1);
        setNewListTx(r);
    }

    const validate = (form = data, nodo = null, k = null) => {
        let e = errorForm
        Object.keys(form).forEach( val => {
            if(typeof(form[val]) === 'object'){
                switch (data['status_complaint'] + "|" + val) {
                    case '101|complaint':
                    case '101|event':
                        validate(form[val], val)
                        break;
                    case '102|resolve':
                        validate(form[val], val)
                        break;
                    case '103|complaint':
                        validate(form[val], val)
                        break;
                    case '104|resolve':
                        validate(form[val], val)
                        break;
                    case '101|subsequent_events':
                        form[val].map((item, key) => {
                            return validate(item, val, key)
                        })
                        break;
                    default:
                        break;
                }
            } else {
                const validate = (bool) => {
                    if(val === 'quebranto' && quebranto === '0'){
                        bool = false
                    } 
                    if(val === 'id_complaint'){
                        bool = !REGEX_FOLIO.test(data.id_complaint)
                    }
                    if(val === 'remote_account' && account === 'cuenta' && validateSentido(data.resolve.sentido)){
                        bool = !REGEX_REMOTE_ACCOUNT.test(data.resolve.remote_account)
                    }
                    if(val === 'remote_account' && account === 'fideicomiso' && validateSentido(data.resolve.sentido)){
                        bool = !REGEX_REMOTE_FIDEICOMISO.test(data.resolve.remote_account)
                    }
                    if(val === 'ramount' || val === 'quebranto'){
                        bool = !REGEX_AMOUNT.test(data.resolve[String(val)])
                    }
                    if((val === "cdate" || val === "pdate" || val === "remote_account") && nodo === "resolve" && !validateSentido(data.resolve.sentido)){
                        bool = false
                    }
                    if((val === "pdate" && !showPdate) && nodo === "resolve" && validateSentido(data.resolve.sentido)){
                        bool = false
                    }
                    nodo ? e[nodo][val] = bool : e[val] = bool
                }
                const validateEvents = (bool) => {
                    if(e[nodo][k]){
                        e[nodo][k] = {...e[nodo][k], [val]: bool}
                    } else {
                        e[nodo].length > 0 ?  e[nodo] = e[nodo].concat({[val]: bool}) : e[nodo] = [{[val]: bool}]
                    }
                }
                if(!form[val] || form[val] === "0" ){
                    nodo === 'subsequent_events' ? validateEvents(true) : validate(true)
                } else {
                    nodo === 'subsequent_events' ? validateEvents(false) : validate(false)
                }
            }
        })
        
        setErrorForm(JSON.parse(JSON.stringify(e)));
        let found = true;
        for(var i = 0; i < Object.values(e).length; i++) {
            let check = (item) => {
                if(Object.values(item).includes(true)){
                   return true;
                }
            }
            if (Array.isArray(Object.values(e)[i])) {
                var values : any = Object.values(e)[i];
		        // eslint-disable-next-line
                values.map((item) => check(item) ? found = false : null);

            } else if (typeof(Object.values(e)[i]) === 'object') {
                if(check(Object.values(e)[i])){
                    found = false;
                    break;
                } 
            } else if(Object.values(e)[i]){
                found = false;
                break;
            }
        }

        setDisabled(!found)
        return found
    }

    const send = async () => {
        if(validate()){
            props.changeLoader(true);
            setZPos(-1)
            var payload = {
                operation: 'add',
                data: data
            }

            let create = await createChargeback(data.complaint.description, data.complaint.reason);
            if(create){
                let request = await API.service('r27', payload, props.pos, props.changeAlert, props.changeLoader, props.history);
                if (request.status === 200) {
                    if (request.data.data.response === 'OK') {
                        props.changeAlert(true, 'success', 'Reclamación generada con éxito');
                        closelightbox();
                        setZPos(45)
                        props.changeLoader(false);
                        if(props.hasFilter){
                            props.filter()
                        }
                    } else {
                        let detail = request.data.data.message;
                        props.changeAlert(true, "error", "Error al generar registro. " + detail);
                    }
                }
            }
            setZPos(45)
            props.changeLoader(false);
        }
    }

    const update = async () => {
        if(validate()){
            props.changeLoader(true);
            setZPos(-1)
            var payload = {
                operation: "update",
                data: data
            }
            
            if(data['status_complaint'] !== oldStatusRec){
                delete payload['data']['_id']
                payload["operation"] = "add"
            } else {
                payload['data']['_id'] = props.data._id.$oid
            }

            let request = await API.service('r27', payload, props.pos, props.changeAlert, props.changeLoader, props.history);
            if (request.status === 200) {
                if (request.data.data.response === 'OK') {
                    props.changeAlert(true, 'success', 'Reclamación atualizada con éxito');
                    if(props.hasFilter){
                        props.filter()
                    }
                    if(payload["operation"] === "add"){
                        let reason = resolveOptions.filter((item) => item.k === data.resolve.sentido)[0].v
                        await updateChargeback(reason)
                    }
                    closelightbox();
                    props.changeLoader(false);
                } else {
                    let detail = request.data.data.message;
                    props.changeAlert(true, "error", "Error al actualizar registro. " + detail);
                }
            }
            setZPos(45)
            props.changeLoader(false);       
        }
    }

    const createChargeback = async (comment, reason) => {
        var chargeData = {
            data: {
                transaction_uuid: props.data.uuid,
                space_uuid: props.spaceUuid,
                folio: data.id_complaint,
                reason: reason,
                amount: props.data.amount,
                commerce: props.data.concept,
                customer_detail: comment,
                type: "r27"
            },
            payload: {
                se: JSON.parse(localStorage.session).email
            }
        }

        var request = await API.service('chargebackCreate', chargeData, props.pos, props.changeAlert, props.changeLoader, props.history);
        if((request.data.data.response === "OK" && request.data.data.content["detail_status"] !== "declined") || request.data.data['exception']['code'] === '0005.042.004'){
            return true
        } else {
            props.changeAlert(true, 'error', 'Error al crear aclaración: ' + (request.data.data["code"] ? request.data.data["code"] : "El registro no cumple las reglas establecidas"));
            return false
        }
    }

    const updateChargeback = async (reason) => {
        var chargeData = {
            data: {
                transaction_uuid: props.data.uuid,
                reason: reason,
                status: "done",
                detail_status: validateSentido(data.resolve.sentido) ? "approved" : "declined",
            },
            payload: {
                se: JSON.parse(localStorage.session).email
            }
        }

        var request = await API.service('chargebackUpdate', chargeData, props.pos, props.changeAlert, props.changeLoader, props.history);
        if(request.data.data.response === "OK"){
            props.changeAlert(true, 'success', 'Aclaración actualizada con éxito');
            if(props.hasFilter){
                props.filter()
            }
        } else {
            props.changeAlert(true, 'error', 'Error al actualizar aclaración.');
        }
    }

    const handleAccount = (e) => {
        setAccount(e.target.value)
    }

    const findTx = async (page = 1, rows= rowsPerPage) => {
		let data = {
			space: {uuid: props.spaceUuid},
			filter: {
				genericFilters: [
                    {start_date: newDates["startDate"]},
                    {end_date: newDates["endDate"]}
                ],
				results_per_page: rows,
				page_number: page
			}
		}

		props.changeLoader(true);
        setZPos(-1)

		let request = await API.service('spaceListTx', data, props.pos, props.changeAlert, props.changeLoader, props.history);
		if (request.status === 200 && request.data.data.response === 'OK') {
			for (let i = 0; i < request.data.data.widget.length; i++) {
				let widget = request.data.data.widget[i];
				if (widget.type === 'spaceListTx') {
                    let allowStatus = widget.data.content.filter((item) => ["approved", "on_transit", "confirmed", "settled", "accepted", "reversed" ].indexOf(item.status) > -1)
                    setListTx(allowStatus)
                    setTotalRows(widget.data.pagination.totalDocuments)
				}
			}
		}
        setZPos(45)
		props.changeLoader(false);
	}
    const changePage = (action, page, rows= rowsPerPage) => {
		setPage(page+1);
		findTx(page+1, rows);
	}

	const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
		setRowsPerPage(JSON.parse(JSON.stringify(event.target.value)));
		changePage(null, 0, parseInt(event.target.value, 10));
	};

    const updateDates = (data, check) => {
		setNewDates({
			startDate: parseDate(data.startDate, "start"),
			endDate: parseDate(data.endDate, "end")
		});
		setIsValid(check);
	}
    const validateSentido = (item) => {
        if(['701', '702', '703', '704', '705'].indexOf(item) > -1){
            return false
        } else {
            return true
        }
    }

    return (
        <Dialog open={true} sx={{zIndex: zPos}} maxWidth={"md"} fullWidth>
            <ModalStyle property={String(disabled)}>
                <DialogTitle>
                    R27
                    <IconButton id="headButton" onClick={closelightbox}><Close/></IconButton>
                </DialogTitle>

                <DialogContent>
                <Grid container spacing={2} pt={1}>
                    { step === 0 &&
                        <Grid item xs={6}>
                            Estatus de la Reclamación:
                            <TextField select value={data.status_complaint} onChange={handleChange.bind(this, "", "status_complaint")} size="small" fullWidth >
                                <MenuItem value={-1} disabled>Seleccione</MenuItem>
                                {statusOptions.map((item) => (
                                    <MenuItem key={`state-${item.key}`} value={item.value}>{item.label}</MenuItem>
                                ))}
                            </TextField>
                        </Grid>
                    }
                    { step === 1 &&
                        <>
                            <Grid item xs={6}>
                                <TextField label={"Estatus de la Reclamación"} select value={data.status_complaint} onChange={handleChange.bind(this, "", "status_complaint")} size="small" fullWidth >
                                    <MenuItem value={-1} disabled>Seleccione</MenuItem>
                                    {statusOptions.map((item) => (
                                        <MenuItem key={`state-${item.key}`} value={item.value}>{item.label}</MenuItem>
                                    ))}
                                </TextField>
                            </Grid>
                            <Grid item xs={12} style={{fontWeight: "bolder"}}>
                                <hr/> Campos automáticos
                            </Grid>
                            <Grid item xs={6}>
                                Fecha de actualización de estatus: <b>{moment(data.udate_status?.substring(0, 10)).format("D MMMM YYYY")}</b>
                            </Grid>
                            {data.status_complaint === "101" &&
                                <>                                
                                <Grid item xs={6}>
                                    Fecha de evento: <b>{format(data.event.cdate)}</b>
                                </Grid>
                                <Grid item xs={6}>
                                    Identificador del cliente: <b>{data.customer_uuid}</b>
                                </Grid>
                                <Grid item xs={6}>
                                    Identificador de la Cuenta: <b>{data.id_account}</b>
                                </Grid>
                                <Grid item xs={6}>
                                    Importe valorizado en moneda nacional: <b>{props.data.amountFormated}</b>
                                </Grid>
                                <Grid item xs={6}>
                                    Identificador del Movimiento: <b>{data.movement_id}</b>
                                </Grid>
                                </>
                            }
                            {(data.status_complaint === "102" || data.status_complaint === "104") && 
                                <>
                                <Grid item xs={6}>
                                    Quebranto para albo: <b>{data.resolve.quebranto}</b>
                                </Grid>
                                <Grid item xs={6}>
                                    Importe abonado al cliente: <b>{data.resolve.amount}</b> 
                                </Grid>                            
                                <Grid container item xs={6} spacing={2}>
                                    <Grid item xs={'auto'}>Importe recuperado:</Grid>
                                    <Grid item xs={'auto'} mt={-1}>
                                        <TextField select onChange={handleChange.bind(this, "", "importe_recuperado")} value={recuperado} size="small" fullWidth >
                                            <MenuItem value={-1} disabled>Seleccione</MenuItem>
                                            {importOptions.map((item) => (
                                                !validateSentido(data.resolve.sentido) ? 
                                                item.key !== '2' && <MenuItem key={`import-${item.key}`} value={item.value}>{item.label}</MenuItem> :
                                                <MenuItem key={`import-${item.key}`} value={item.value}>{item.label}</MenuItem>
                                            ))}
                                        </TextField>
                                    </Grid>
                                    <Grid item xs={'auto'} mt={-1} >
                                        {showImporteRecuperado && 
                                            <TextField type={'number'} value={data.resolve.ramount} onChange={handleChange.bind(this, "resolve", "ramount")} InputProps={{inputProps: { min: 0 }}} error={errorForm.resolve.quebranto} helperText={errorForm.resolve.quebranto ? text[0] : ''} size="small" fullWidth />
                                        }
                                    </Grid>
                                </Grid>
                                {msnErrorQuebrantado !== "" &&
                                    <Grid item xs={12} color={"red"} fontSize={11}>{msnErrorQuebrantado}</Grid>
                                }
                                </>
                            }

                            <Grid item xs={12} style={{fontWeight: "bolder"}}>
                                <hr/> Campos Multiopción
                            </Grid>
                            <Grid item xs={6}>
                                <TextField label="Folio de Reclamación" disabled={(hasAction("updateFolio") ? false : data.status_complaint !== "101") && data.id_complaint !== ""} value={data.id_complaint} onChange={handleChange.bind(this, "", "id_complaint")} inputProps={{ minLength: 8, maxLength: 22, style: { textTransform: "uppercase" }}} error={errorForm.id_complaint} helperText={errorForm.id_complaint ? text[2] : ''} size="small" fullWidth/>
                            </Grid>
                            {data.status_complaint === "101" &&
                                <>
                                    <Grid item xs={6}>
                                        <TextField label="Motivo de Reclamación" select value={reasonOptions.length > 0 ? data.complaint.reason : 0} onChange={handleChange.bind(this, "complaint", "reason")} error={errorForm.complaint.reason} helperText={errorForm.complaint.reason ? text[0] : ''} size="small" fullWidth >
                                            <MenuItem value={0} disabled>Seleccione</MenuItem>
                                            {reasonOptions.map((item) => (
                                                <MenuItem key={`reason-${item.k}`} value={item.k}>{item.v}</MenuItem>
                                            ))}
                                        </TextField>
                                    </Grid>
                                    <Grid item xs={6}>
                                        <TextField label="Objeto del Evento" select value={data.event.object || 0} onChange={handleChange.bind(this, "event", "object")} error={errorForm.event.object} helperText={errorForm.event.object ? text[0] : ''} size="small" fullWidth >
                                            <MenuItem value={0} disabled>Seleccione</MenuItem>
                                            {eventOptions.map((item) => (
                                                <MenuItem key={`object-${item.key}`} value={item.value}>{item.label}</MenuItem>
                                            ))}
                                        </TextField>
                                    </Grid>
                                    <Grid item xs={6}>
                                        <TextField label="Tipo de reclamación" select value={data.complaint.type} defaultValue={0} onChange={handleChange.bind(this, "complaint", "type")} error={errorForm.complaint.type} helperText={errorForm.complaint.type ? text[0] : ''} size="small" fullWidth >
                                            <MenuItem value={0} disabled>Seleccione</MenuItem>
                                            {claimsOptions.map((item) => (
                                                <MenuItem disabled key={`type-${item.key}`} value={item.value}>{item.label}</MenuItem>
                                            ))}
                                        </TextField>
                                    </Grid>
                                    <Grid item xs={6}>
                                        <TextField label="Canal en el cual se realizó la operación no reconocida" select value={data.event.channel} defaultValue={0} onChange={handleChange.bind(this, "event", "channel")} error={errorForm.event.channel} helperText={errorForm.event.channel ? text[0] : ''} size="small" fullWidth >
                                            <MenuItem value={0} disabled>Seleccione</MenuItem>
                                            {operationOptions.map((item) => (
                                                <MenuItem key={`reason-${item.key}`} value={item.value}>{item.label}</MenuItem>
                                            ))}
                                        </TextField>
                                    </Grid>
                                </>
                            }

                            {(data.status_complaint === "102" || data.status_complaint === "104") &&
                                <>
                                {validateSentido(data.resolve.sentido) && 
                                    <>
                                    {showPdate &&<Grid item xs={6}>
                                        <TextField type={"date"} label={"Fecha de recuperación de los fondos"} InputLabelProps={{ shrink: true }}
                                            value={ data.resolve.pdate ? new Date(data.resolve.pdate).toJSON().substring(0, 10) : data.resolve.pdate  } error={errorForm.resolve.pdate} helperText={errorForm.resolve.pdate ? text[1] : ''} size="small" fullWidth 
                                            onChange={handleChange.bind(this, "resolve", "pdate")}                
                                        />
                                    </Grid>
                                    }
                                    <Grid item xs={6}>
                                        <TextField type={"date"} label={"Fecha de abono a la cuenta del cliente"} InputLabelProps={{ shrink: true }}
                                            value={ data.resolve.cdate ? new Date(data.resolve.cdate).toJSON().substring(0, 10) : data.resolve.cdate } error={errorForm.resolve.cdate} helperText={errorForm.resolve.cdate ? text[1] : ''} size="small" fullWidth
                                            onChange={handleChange.bind(this, "resolve", "cdate")}
                                        />
                                    </Grid>
                                    </>
                                }
                                <Grid item xs={6}>
                                    <TextField type={"date"} label={"Fecha de resolución"} InputLabelProps={{ shrink: true }}
                                        value={data.resolve.rdate ? new Date(data.resolve.rdate).toJSON().substring(0, 10) : data.resolve.rdate } size="small" fullWidth 
                                        onChange={handleChange.bind(this, "resolve", "rdate")}
                                    />
                                </Grid>
                                <Grid item xs={6}>
                                    <TextField label="Sentido de la resolución" select value={data.resolve.sentido} defaultValue={0} onChange={handleChange.bind(this, "resolve", "sentido")} error={errorForm.resolve.sentido} helperText={errorForm.resolve.sentido ? text[0] : ''} size="small" fullWidth >
                                        <MenuItem value={0} disabled>Seleccione</MenuItem>
                                        {resolveOptions.map((item) => (
                                            <MenuItem key={`resolve-${item.k}`} value={item.k}>{item.v}</MenuItem>
                                        ))}
                                    </TextField>
                                </Grid>
                                {validateSentido(data.resolve.sentido) && 
                                    <>
                                    <Grid item xs={6}>
                                        <TextField label="Receptor para importe recuperado" select value={account} defaultValue={'cuenta'} onChange={handleAccount.bind(this)} size="small" fullWidth >
                                            {accountType.map((item) => (
                                                <MenuItem key={`type-${item.key}`} value={item.value}>{item.label}</MenuItem>
                                            ))}
                                        </TextField>
                                    </Grid>
                                    <Grid item xs={6}>
                                        <Tooltip title={`Identificador de ${account} de la institución donde se recibe el importe recuperado`} arrow >
                                            <TextField label={`Identificador de ${account} de la institución donde se recibe el importe recuperado`} value={data.resolve.remote_account} onChange={handleChange.bind(this, "resolve", "remote_account")} error={errorForm.resolve.remote_account } helperText={errorForm.resolve.remote_account ? text[2] : ''} inputProps={{ style: { textTransform: "uppercase" } }} size="small" fullWidth/>
                                        </Tooltip>
                                    </Grid>
                                    </>
                                }
                                </>
                            }
                            {(data.status_complaint === "101" || data.status_complaint === "103") &&
                                <>
                                    <Grid item xs={6}>
                                        <TextField label="Canal de Recepción" select value={data.complaint.channel} onChange={handleChange.bind(this, "complaint", "channel")} error={errorForm.complaint.channel} helperText={errorForm.complaint.channel ? text[0] : ''} size="small" fullWidth >
                                            <MenuItem value={0} disabled>Seleccione</MenuItem>
                                            {channelOptions.map((item) => (
                                                <MenuItem key={`channel-${item.key}`} value={item.value}>{item.label}</MenuItem>
                                            ))}
                                        </TextField>
                                    </Grid>
                                    <Grid item xs={6}>
                                        <TextField type={"date"} label={"Fecha de Reclamación"} InputLabelProps={{ shrink: true }} sx={{cursor: 'pointer'}}
                                            value={ data.complaint.cdate ? new Date(data.complaint.cdate).toJSON().substring(0, 10) : data.complaint.cdate  } size="small" fullWidth 
                                            onChange={handleChange.bind(this, "complaint", "cdate")}
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextField
                                            multiline inputProps={{ maxLength: 200 }} minRows={2} value={data.complaint.description} onChange={handleChange.bind(this, "complaint", "description")} label="Descripción de Reclamación" size="small" fullWidth error={errorForm.complaint.description} helperText={errorForm.complaint.description ? 'Campo obligatorio. Máximo 200 caracteres' : ''} />
                                    </Grid> 

                                    {data.complaint.type === "302" && listTx.length > 0 &&
                                        <>
                                            <Grid item xs={12} style={{fontWeight: "bolder"}}>
                                                <hr/> Seleccionar eventos subsecuentes 
                                            </Grid>
                                            <Grid item xs={12} display={"flex"} alignItems={"center"} justifyContent={"space-between"}>
                                                <DateRangePicker width={400} updateDates={updateDates.bind(this)} startDate={newDates["startDate"]} endDate={newDates["endDate"]}/>
                                                <IconButton disabled={isValid} onClick={() => findTx()} sx={{padding: "0 !important"}} ><Search sx={{padding: "7px", borderRadius: 2, boxSizing: "content-box", color: "white", backgroundColor: !isValid ? "#8bc179" : "#EDF0F4" }}/></IconButton>
                                                <CustomPagination 
                                                    rows={totalRows}
                                                    page={page - 1}
                                                    rowsPerPage={rowsPerPage}
                                                    handleChangePage={changePage}
                                                    handleChangeRowsPerPage={handleChangeRowsPerPage}
                                                    label={false}
                                                />
                                            </Grid>

                                            <Grid item xs={12}>
                                                <TextField label="Movimientos" select value={0} onChange={handleChange.bind(this, "", "subsequent_events")} size="small" fullWidth >
                                                    <MenuItem value={0} disabled>Seleccione</MenuItem>
                                                    {listTx.map((item, key) => (
                                                        <MenuItem key={`tx-${key}`} value={item}>{item.amountFormated} - {formatNumericDate(item.cdate)} - {item.description}</MenuItem>
                                                    ))}
                                                </TextField>
                                            </Grid>
                                            <Grid item xs={12}><hr/></Grid>
                                        </>
                                    }
                                    {data.complaint.type === "302" && data['subsequent_events']?.length > 0 &&
                                        data['subsequent_events'].map((item, key) => {
                                            return <Grid container item spacing={2} pb={3} key={key}>
                                                <Grid item xs={12} display={'flex'}>{!hasUpdate && <Close fontSize='small' onClick={() => deleteEvent(key)} titleAccess={`Eliminar`} cursor={"pointer"} sx={{marginRight: 1}}/>}Evento - {key + 1}</Grid>
                                                <Grid item xs={6} fontSize={14} fontStyle={"italic"}>
                                                    Nombre del Comercio: {item.concept}
                                                </Grid>
                                                <Grid item xs={6} fontSize={14} fontStyle={"italic"}>
                                                    Tipo de compra: {item.tipoTx}
                                                </Grid>

                                                <Grid item xs={6}>
                                                    <TextField type={"date"} disabled label={"Fecha de evento"} InputLabelProps={{ shrink: true }} sx={{cursor: 'pointer'}}
                                                        value={ item.cdate ? new Date(item.cdate).toJSON().substring(0, 10) : item.cdate} size="small" fullWidth 
                                                        onChange={handleChange.bind(this, "subsequent_events", "cdate")}                 
                                                    />
                                                </Grid>
                                                <Grid item xs={6} >
                                                    <TextField label={'Importe valorizado en moneda nacional'} disabled value={item.amount} type={'number'} onChange={handleChange.bind(this, "subsequent_events", "amount")} InputProps={{inputProps: { min: 0 }}} size="small" fullWidth />
                                                </Grid>
                                                <Grid item xs={6}>
                                                    <TextField label="Objeto del Evento" select value={item.object} defaultValue={0} onChange={handleChange.bind(this, "subsequent_events", `object-${key}`)}  error={errorForm['subsequent_events'] ? errorForm['subsequent_events'][key]?.object : ""} helperText={errorForm['subsequent_events'] ? errorForm['subsequent_events'][key]?.object : text[0] ? '' : ''} size="small" fullWidth >
                                                        <MenuItem value={0} disabled>Seleccione</MenuItem>
                                                        {eventOptions.map((item) => (
                                                            <MenuItem key={`reason-${item.key}`} value={item.value}>{item.label}</MenuItem>
                                                        ))}
                                                    </TextField>
                                                </Grid>
                                                <Grid item xs={6}>
                                                    <TextField label="Canal en el cual se realizó la operación no reconocida" select value={item.channel} onChange={handleChange.bind(this, "subsequent_events", `channel-${key}`)} error={errorForm['subsequent_events'] ? errorForm['subsequent_events'][key]?.channel : ""} helperText={errorForm['subsequent_events'] ? errorForm['subsequent_events'][key]?.channel : text[0] ? '' : ''} size="small" fullWidth >
                                                        <MenuItem value={''} disabled>Seleccione</MenuItem>
                                                        {operationOptions.map((item) => (
                                                            <MenuItem key={`channel-${item.key}`} value={item.value}>{item.label}</MenuItem>
                                                        ))}
                                                    </TextField>
                                                </Grid>
                                            </Grid>
                                        })
                                    }
                                </>
                            }
                        </>
                    }
                </Grid>
                </DialogContent>

                <DialogActions>    
                    <Button id='buttonCancel' variant="outlined" onClick={closelightbox} >Cancelar</Button>
                    {step === 1 &&
                        ((!hasUpdate && <Button disabled={disabled} variant="contained" onClick={send}>Guardar</Button>) ||
                        (hasUpdate && <Button disabled={disabled} variant="contained" onClick={update}>Actualizar</Button>))
                    }
                </DialogActions>
            </ModalStyle>
        </Dialog>
    );
}
export default R27;